import Service from './Components/Service/Service';


import './App.css';

const App = () => {
  return (
    <div className="App">
      <Service/>
    </div>
  );
}

export default App;
